import { authPut } from "@api/auth/auth";
import { DEPLOYMENT_URL } from "@constants";
import { UpdateFindingBody } from "@types";

import { Finding } from "@pages/findings/types";

export const updateDeploymentFinding = (
  deploymentId: string,
  findingId: number,
  update: UpdateFindingBody
) => {
  return authPut<UpdateFindingBody, Finding>(
    `${DEPLOYMENT_URL}/${deploymentId}/issues/${findingId}`,
    update
  );
};
